export const STANDART_CHART_HEIGHT = 315;

export const CHART_CONTAINER_HEIGHT = 428;

export const SMALL_CHART_HEIGHT = 260;

export const DEFAULT_STATISTICS_DATE_FORMAT = "MMM DD, YY";
